import { render, staticRenderFns } from "./addons.page.vue?vue&type=template&id=15f91d8a&scoped=true&"
import script from "./addons.page.vue?vue&type=script&lang=js&"
export * from "./addons.page.vue?vue&type=script&lang=js&"
import style0 from "./addons.page.vue?vue&type=style&index=0&id=15f91d8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f91d8a",
  null
  
)

export default component.exports